/* @flow */

import React from 'react';
import { QueryRenderer, graphql } from 'react-relay';
import { defineMessages, injectIntl } from 'react-intl';
import getter from 'dibs-object-getter';

import { Country } from './Country';
import { getEnvironment } from '../../../relayModernEnvironment';
import { logError } from '../../../helpers';

import type { intlShape } from 'react-intl';

const environment = getEnvironment();

const messages = defineMessages({
    us: {
        id: 'abt.matchmaker.countryDropdownRenderer.country_us',
        defaultMessage: 'United States',
    },
    uk: {
        id: 'abt.matchmaker.countryDropdownRenderer.country_uk',
        defaultMessage: 'United Kingdom',
    },
    can: {
        id: 'abt.matchmaker.countryDropdownRenderer.country_can',
        defaultMessage: 'Canada',
    },
    france: {
        id: 'abt.matchmaker.countryDropdownRenderer.country_fran',
        defaultMessage: 'France',
    },
});

type OuterProps = {|
    errorMessage: string,
    intl: intlShape,
    onChange: (e: SyntheticEvent<HTMLSelectElement>) => void,
    value: string,
|};

export function CountryDropdownRendererComponent(outerProps: OuterProps) {
    const { intl } = outerProps;

    const defaultOptions = [
        {
            value: 'US',
            label: intl.formatMessage(messages.us),
        },
        {
            value: 'UK',
            label: intl.formatMessage(messages.uk),
        },
        {
            value: 'CA',
            label: intl.formatMessage(messages.can),
        },
        {
            value: 'FR',
            label: intl.formatMessage(messages.france),
        },
    ];

    return (
        <QueryRenderer
            environment={environment}
            query={graphql`
                query CountryDropdownRendererQuery {
                    viewer {
                        geography {
                            countries {
                                abbreviation
                                name
                            }
                        }
                    }
                }
            `}
            variables={{}}
            render={({ props, error }) => {
                if (error) {
                    logError(error);
                }

                let countryOptions = defaultOptions;
                if (props) {
                    const countries =
                        getter(props)
                            .at('viewer')
                            .at('geography')
                            .value('countries') || [];

                    countryOptions = countries.map(country => ({
                        label: getter(country).value('name') || '',
                        value: getter(country).value('abbreviation') || '',
                    }));
                }

                return <Country {...outerProps} countryOptions={countryOptions} />;
            }}
        />
    );
}

export const CountryDropdownRenderer = injectIntl(CountryDropdownRendererComponent);
